var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sign-page',{attrs:{"title-text":"考核项目","request":_vm.request,"column-list":_vm.columnList,"form-parms-add":_vm.formParms,"dealSearchParm":_vm.dealSearchParm,"form-parms-update":_vm.formParms,"dealFormData":_vm.dealFormData,"need-data-file":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }